<template>
  <div class="alert" :class="[alertExtendedClass, alertSlimClass]">
    <div class="alert__icon">
      <i :class="alertIconClass"></i>
    </div>
    <div class="alert__text">
      <p v-for="(item, index) in messages" :key="index" v-html="item"></p>

      <slot></slot>
    </div>
    <button
      v-if="dismissible"
      type="button"
      class="alert__btn-close"
      :data-bs-dismiss="dismissByNative"
      :aria-label="closeAriaLable"
      @click="$emit('close')"></button>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: 'danger',
      // type value should be any of these, or empty: info || warning || danger
      type: String,
    },
    messages: {
      type: Array,
      default: () => [],
    },
    dismissible: {
      default: true,
      type: Boolean,
    },
    closeAriaLable: {
      default: 'Close alert',
      type: String,
    },
    dismissByNative: {
      default: 'alert',
      type: String,
    },
    slim: {
      default: false,
      type: Boolean,
    },
  },
  emits: ['close'],
  computed: {
    alertExtendedClass() {
      let cls = ''

      if (this.type === 'info') {
        cls = 'alert--info'
      } else if (this.type === 'warning') {
        cls = 'alert--warning'
      } else if (this.type === 'danger') {
        cls = 'alert--danger'
      }

      return cls
    },
    alertIconClass() {
      let cls = ''

      if (this.type === 'info') {
        cls = 'icon-info'
      } else if (this.type === 'warning') {
        cls = 'icon-exclamation-mark-circle'
      } else if (this.type === 'danger') {
        cls = 'icon-circle-remove'
      }

      return cls
    },
    alertSlimClass() {
      return this.slim ? 'alert--slim' : ''
    },
  },
}
</script>
